import { Form, Input, InputNumber, Modal, Radio, Select } from 'antd';
import React, { FC, useMemo } from 'react';
import styles from './index.less';
import RewardCondition, {
  TRewardConditionRowType,
} from '@/pages/backend/cardCampSettings/rewardSettings/rewardCondition';
import { get, isEmpty, isUndefined } from 'lodash';
import { info } from '@/services/CardCampRequest';
import { useRequest } from 'ahooks';
import { useParams } from 'umi';
import { createReward, updateReward } from '@/services/ConsoleRequest';
import ImageModuleUpload from '@/pages/backend/cardCampSettings/recruitPageSettings/ImageModuleUpload';
import { PlusOutlined } from '@ant-design/icons';
import { TConsoleReward } from '@/types/console/reward';
import { TConsoleSetingsCoupon } from '@/types/console/coupon';
import RewardIcon from './rewardIcon.png';
import CampSettingsEditor from '@/pages/backend/components/CampSettingsEditor/index';

type TCreateRewardModal = {
  visible: boolean;
  onClose: () => void;
  onOk: () => void;
  activeRewardInfo?: TConsoleReward;
  couponList?: TConsoleSetingsCoupon[];
  index?: number;
};

const CreateRewardModal: FC<TCreateRewardModal> = ({
  activeRewardInfo,
  onOk,
  onClose,
  visible,
  couponList,
  index = 0,
}) => {
  const [form] = Form.useForm();
  const content = Form.useWatch('content', form);
  const picture = Form.useWatch('picture', form);
  const { id: campId } = useParams<{ id: string }>();
  const { data } = useRequest(() => {
    return info(campId);
  });

  const couponListData = useMemo(() => {
    if (Array.isArray(couponList)) {
      return couponList
        .filter(
          (item) =>
            ['0', '2'].includes(item.couponModule) ||
            (item.couponModule === '1' && item.couponType === '2'),
        )
        .map((item) => {
          return {
            label: item.couponName,
            value: Number(item.couponId),
          };
        });
    }
    return [];
  }, [couponList]);
  const { loading, runAsync } = useRequest(
    (params) => {
      if (activeRewardInfo) {
        return updateReward(activeRewardInfo.id, {
          ...params,
          index: activeRewardInfo.index || index,
        });
      }
      return createReward({ ...params, index });
    },
    {
      manual: true,
      onSuccess: () => {
        onOk();
      },
    },
  );

  return (
    <Modal
      destroyOnClose
      wrapClassName={styles.create_reward}
      width={800}
      centered
      open={visible}
      onClose={onClose}
      title={activeRewardInfo ? '修改打卡奖励' : '新建打卡奖励'}
      okText="保存"
      onCancel={onClose}
      okButtonProps={{
        loading,
        disabled: loading,
      }}
      confirmLoading={loading}
      onOk={async () => {
        const data = await form.validateFields();
        console.log('表单是');
        console.log(data);
        if (!isUndefined(get(data, 'contentInfo.customTips'))) {
          data.contentInfo.customTips = JSON.stringify(data.contentInfo.customTips);
        }
        await runAsync(data);
      }}
    >
      {visible && (
        <Form
          preserve={false}
          form={form}
          initialValues={
            activeRewardInfo
              ? { ...activeRewardInfo }
              : { cardCampId: campId, content: 0, name: undefined, picture: RewardIcon }
          }
        >
          <Form.Item hidden name="cardCampId" />
          <Form.Item
            labelCol={{ span: 3 }}
            name="name"
            label="奖励名称"
            rules={[{ required: true, message: '请输入奖励名称' }]}
          >
            <Input maxLength={20} showCount />
          </Form.Item>
          <Form.Item name="condition_error" hidden />
          <Form.Item
            labelCol={{ span: 3 }}
            name="condition"
            label="兑换条件"
            required
            rules={[
              {
                validator: (_, value) => {
                  const checkItem: Record<TRewardConditionRowType, boolean> = {
                    selectedRank: false,
                    selectedEarnCredits: false,
                    selectedFinishNodes: false,
                    selectedSuccessForCard: false,
                  };
                  let checkItemData: Partial<Record<TRewardConditionRowType, boolean>> = {};
                  for (const field in value) {
                    if (field in checkItem && value[field]) {
                      checkItemData[field as TRewardConditionRowType] = value[field];
                    }
                  }
                  if (value?.selectedEarnCredits && !value.earnCredits) {
                    //form.setFieldsValue({
                    //  condition_error: '请设置获得学分',
                    //});
                    return Promise.reject(new Error('请设置获得学分'));
                  }
                  if (value?.selectedFinishNodes && isEmpty(value.finishNodes)) {
                    //form.setFieldsValue({
                    //  condition_error: '请设置完成节点',
                    //});
                    return Promise.reject(new Error('请设置完成节点'));
                  }
                  if (value?.selectedRank) {
                    if (
                      value?.minRankAfterFinishCamp !== undefined &&
                      value?.maxRankAfterFinishCamp !== undefined
                    ) {
                      if (value.minRankAfterFinishCamp > value.maxRankAfterFinishCamp) {
                        //form.setFieldsValue({
                        //  condition_error: '右侧的名次下限不能小于左侧的名次上限',
                        //});
                        return Promise.reject(new Error('右侧的名次下限不能小于左侧的名次上限'));
                      }
                    } else {
                      return Promise.reject(new Error('请设置名次的上下限'));
                    }
                  }
                  return !isEmpty(checkItemData)
                    ? Promise.resolve()
                    : Promise.reject(new Error('至少选中一个条件'));
                },
              },
            ]}
          >
            <RewardCondition defaultValue={activeRewardInfo?.condition} />
          </Form.Item>
          <Form.Item labelCol={{ span: 3 }} name="content" label="奖励内容">
            <Radio.Group
              onChange={(e) => {
                const chooseValue = e.target.value;
                if ([1, 2].includes(chooseValue)) {
                  if (picture === RewardIcon) {
                    form.setFieldsValue({ picture: undefined });
                  }
                } else {
                  if (!picture) {
                    form.setFieldsValue({ picture: RewardIcon });
                  }
                }
              }}
              options={[
                { label: 'F币', value: 0 },
                { label: '优惠券', value: 1 },
                { label: '自定义', value: 2 },
              ]}
            />
          </Form.Item>
          <Form.Item
            noStyle
            shouldUpdate={(prevValues, curValues) => prevValues.content !== curValues.content}
          >
            {({ getFieldValue }) => {
              const contentValue = getFieldValue('content');
              if (contentValue === 0) {
                return (
                  <Form.Item
                    rules={[{ required: true, message: '请输入' }]}
                    help={<div>成本将计入此打卡营所有者 {data?.data?.ownerName} 所在团队</div>}
                    name={['contentInfo', 'amountOfMoney']}
                    label="金额"
                    labelCol={{ span: 3 }}
                  >
                    <InputNumber min={0} precision={2} placeholder="请输入" />
                  </Form.Item>
                );
              } else if (contentValue === 1) {
                return (
                  <>
                    <Form.Item
                      name={['contentInfo', 'type']}
                      rules={[{ required: true, message: '请选择优惠券类型' }]}
                      label="优惠券类型"
                      labelCol={{ span: 3 }}
                    >
                      <Select loading={isEmpty(couponListData)} options={couponListData} />
                    </Form.Item>
                    <Form.Item
                      name={['contentInfo', 'amountOfMoney']}
                      rules={[{ required: true, message: '请输入' }]}
                      label="面值"
                      labelCol={{ span: 3 }}
                    >
                      <InputNumber min={0} precision={2} placeholder="请输入" />
                    </Form.Item>
                    <Form.Item
                      name={['contentInfo', 'netAddr']}
                      rules={[{ required: true, message: '请输入' }]}
                      label="使用地址"
                      labelCol={{ span: 3 }}
                    >
                      <Input placeholder="请输入使用此优惠券的网址" />
                    </Form.Item>
                    <Form.Item
                      name={['contentInfo', 'validDays']}
                      rules={[{ required: true, message: '请输入' }]}
                      label="有效期"
                      labelCol={{ span: 3 }}
                    >
                      <InputNumber placeholder="请输入" min={0} precision={0} addonAfter="天" />
                    </Form.Item>
                  </>
                );
              } else {
                return (
                  <Form.Item
                    name={['contentInfo', 'customTips']}
                    rules={[{ required: true, message: '请输入' }]}
                    label="领取方式"
                    labelCol={{ span: 3 }}
                    initialValue={
                      !isUndefined(get(activeRewardInfo, 'contentInfo.customTips'))
                        ? JSON.parse(get(activeRewardInfo, 'contentInfo.customTips', ''))
                        : ''
                    }
                    valuePropName="content"
                  >
                    <CampSettingsEditor
                      onChange={(data) => {
                        console.log('onChange触发', data);
                      }}
                      placeholder={'请输入…'}
                      style={{ height: '240px' }}
                    />
                  </Form.Item>
                );
              }
            }}
          </Form.Item>
          <Form.Item
            label="图片"
            name="picture"
            labelCol={{ span: 3 }}
            rules={content !== 0 ? [{ required: true, message: '请上传' }] : undefined}
          >
            <ImageModuleUpload
              maxSize={0.5}
              imageCrop={{ width: 160, height: 160 }}
              help={
                <div className="ant-form-item-explain">
                  支持上传文件大小不超过500KB的.png/.jpg格式图片，尺寸为160px * 160px
                </div>
              }
              uploadButton={
                <div>
                  <PlusOutlined />
                  <p>点击上传</p>
                </div>
              }
            />
          </Form.Item>
          <Form.Item labelCol={{ span: 3 }} name="description" label="奖励说明">
            <Input.TextArea placeholder="请输入" maxLength={500} showCount />
          </Form.Item>
        </Form>
      )}
    </Modal>
  );
};
export default CreateRewardModal;
